// extracted by mini-css-extract-plugin
export default {"modalOverlay":"jK-z","modalContent":"kK-z","header":"lK-z","close":"mK-z"};